import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function GA4RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-KMSRR817XT', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

export default GA4RouteTracker;